import api from "../../../../services/api";

export const getAllCompanies = async (signature: string | null) => {
  const response = await api.post("userService/getAllCompanyList", {
    signature,
  });
  const companies = response?.data?.data?.data || [];

  return companies.map((company: any) => ({
    id: String(company.id),
    name: company.name,
    type: company.type,
  }));
};
